import { render, staticRenderFns } from "./UserBlacklist.vue?vue&type=template&id=0f7754d0&scoped=true"
import script from "./UserBlacklist.vue?vue&type=script&lang=js"
export * from "./UserBlacklist.vue?vue&type=script&lang=js"
import style0 from "./UserBlacklist.vue?vue&type=style&index=0&id=0f7754d0&prod&lang=css"
import style1 from "./UserBlacklist.vue?vue&type=style&index=1&id=0f7754d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f7754d0",
  null
  
)

export default component.exports